module.exports = __webpack_public_path__ + "static/media/mt.f6e3733c.svg";